var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
var CustomLeaf = function (_a) {
    var attributes = _a.attributes, children = _a.children, leaf = _a.leaf;
    if (leaf.color) {
        children = _jsx("span", __assign({ style: { color: leaf.color } }, { children: children }));
    }
    if (leaf.bold) {
        children = _jsx("strong", { children: children });
    }
    if (leaf.italic) {
        children = _jsx("em", { children: children });
    }
    if (leaf.delete) {
        children = _jsx("del", { children: children });
    }
    if (leaf.underline) {
        children = _jsx("u", { children: children });
    }
    return _jsx("span", __assign({}, attributes, { children: children }));
};
export default CustomLeaf;
